module.exports = __webpack_public_path__ + "img/TPT.fc1c3905.png";